"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "teggiano": {
    "55897e35": [{
      "hkey": "e41a8950",
      "slug": "teggiano",
      "name": "Teggiano",
      "primary": true,
      "skipSearch": false
    }],
    "pantano": [{
      "hkey": "e41a8950",
      "slug": "teggiano",
      "name": "Teggiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "443867b5": [{
      "hkey": "e41a8950",
      "slug": "teggiano",
      "name": "Teggiano",
      "primary": true,
      "skipSearch": false
    }],
    "piedimonte": [{
      "hkey": "e41a8950",
      "slug": "teggiano",
      "name": "Teggiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;